/* potties-base.js - scroll-reveal + shared product-card size selector (price/stock/specs). */
(function () {
  function reveal(scope) {
    var els = (scope && scope.querySelectorAll ? scope : document).querySelectorAll('[data-reveal]:not(.is-in)');
    if (!('IntersectionObserver' in window)) { els.forEach(function (e) { e.classList.add('is-in'); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
    els.forEach(function (e) { io.observe(e); });
  }

  var UNIT = { KILOGRAMS: 'kg', KG: 'kg', GRAMS: 'g', G: 'g', MILLIGRAMS: 'mg', MG: 'mg',
    POUNDS: 'lb', LB: 'lb', OUNCES: 'oz', OZ: 'oz',
    LITERS: 'L', LITRES: 'L', L: 'L', MILLILITERS: 'ml', ML: 'ml', CENTILITERS: 'cl', CL: 'cl', CUBIC_METERS: 'm³',
    US_FLUID_OUNCES: 'fl oz', IMPERIAL_FLUID_OUNCES: 'fl oz', US_PINTS: 'pt', US_QUARTS: 'qt', US_GALLONS: 'gal' };
  function fmtMeasure(val, unit) {
    if (val == null || val === '') return null;
    var n = Math.round(Number(val) * 100) / 100;
    n = (n % 1 === 0) ? String(n) : String(Math.round(n * 10) / 10);
    var u = String(unit || '').toUpperCase();
    return n + ' ' + (UNIT[u] || unit || '');
  }

  function initCards(scope) {
    var root = (scope && scope.querySelectorAll) ? scope : document;
    root.querySelectorAll('[data-ptc-card]:not([data-ptc-ready])').forEach(function (card) {
      card.setAttribute('data-ptc-ready', '1');
      var dataEl = card.querySelector('script[data-ptc-json]');
      if (!dataEl) return;
      var data; try { data = JSON.parse(dataEl.textContent); } catch (e) { return; }
      var variants = (data && data.variants) || [];
      if (!variants.length) return;

      var sizeBtns = card.querySelectorAll('[data-ptc-size]');
      var priceEl = card.querySelector('[data-ptc-price]');
      var subEl = card.querySelector('[data-ptc-sub]');
      var stockEl = card.querySelector('[data-ptc-stock]');
      var idInput = card.querySelector('[data-ptc-id]');
      var addBtn = card.querySelector('[data-ptc-add]');
      var trigBtn = card.querySelector('[data-ptc-trigger-id]');
      var img1 = card.querySelector('.ptc__img--1');
      var specs = card.querySelector('[data-ptc-specs]');
      var wCell = card.querySelector('[data-ptc-spec-weight]'), wVal = card.querySelector('[data-ptc-weight]');
      var vCell = card.querySelector('[data-ptc-spec-vol]'), vVal = card.querySelector('[data-ptc-vol]');

      function setPrice(str) {
        if (!priceEl || !str) return;
        var ppw = priceEl.querySelector('.ptc__ppw');
        priceEl.textContent = str + ' ';
        if (ppw) priceEl.appendChild(ppw);
      }
      function byOpt(val) { for (var i = 0; i < variants.length; i++) { if (variants[i].opt === val) return variants[i]; } return null; }

      function apply(vr) {
        if (!vr) return;
        if (idInput) idInput.value = vr.id;
        if (trigBtn) trigBtn.setAttribute('data-variant-id', vr.id);
        setPrice(vr.priceStr);
        if (stockEl) stockEl.innerHTML = vr.available ? '<i></i>In stock' : 'Sold out';
        if (addBtn) { addBtn.disabled = !vr.available; addBtn.textContent = vr.available ? 'Add to cart' : 'Sold out'; }
        if (img1 && vr.img) { img1.src = vr.img; img1.srcset = vr.img; }

        var w = fmtMeasure(vr.wnum, vr.wunit), vol = fmtMeasure(vr.vnum, vr.vunit);
        var anySpec = false;
        if (wCell && wVal) { if (w) { wVal.textContent = w; wCell.hidden = false; anySpec = true; } else { wCell.hidden = true; } }
        if (vCell && vVal) { if (vol) { vVal.textContent = vol; vCell.hidden = false; anySpec = true; } else { vCell.hidden = true; } }
        if (specs) {
          var hasMat = !!specs.querySelector('.ptc__spec:not([data-ptc-spec-weight]):not([data-ptc-spec-vol])');
          specs.hidden = !(anySpec || hasMat);
        }
        if (subEl) subEl.textContent = vol || '';
      }

      if (sizeBtns.length) {
        sizeBtns.forEach(function (btn) {
          btn.addEventListener('click', function () {
            sizeBtns.forEach(function (b) { b.classList.remove('is-active'); });
            btn.classList.add('is-active');
            apply(byOpt(btn.getAttribute('data-value')));
          });
        });
        var active = card.querySelector('[data-ptc-size].is-active') || sizeBtns[0];
        apply(byOpt(active.getAttribute('data-value')) || variants[0]);
      } else {
        apply(variants.filter(function (x) { return x.available; })[0] || variants[0]);
      }
    });
  }

  function initAll(scope) { reveal(scope); initCards(scope); }
  document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target || document); });
})();
